// material-ui imports
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, Typography } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';

// project-imports
import useStyles from './styles';

// third-party
import PropTypes from 'prop-types';

const DialogModal = ({
    open,
    titleText,
    bodyText,
    maxWidth,
    onClose,
    disableBackdropClick = false,
    disableEscapeKeyDown = false,
    showDivider = true,
    hideTitle = false,
    showCloseButton = true,
    titleClass,
    customTitle = false,
    fixedHeight = 'auto',
    ActionsComponent = null
}) => {
    const classes = useStyles();
    const theme = useTheme();
    return (
        <Dialog
            open={open}
            id="modalBody"
            fullWidth
            maxWidth={maxWidth || 'md'}
            onClose={onClose}
            disableBackdropClick={disableBackdropClick || false}
            disableEscapeKeyDown={disableEscapeKeyDown}
            PaperProps={{
                sx: {
                    height: fixedHeight === 'auto' ? 'auto' : `${fixedHeight}% !important`
                }
            }}
        >
            {!hideTitle && (
                <DialogTitle id="responsive-dialog-title" classes={{ root: classes.dialogTitleClass }}>
                    {customTitle || (
                        <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                            {titleText && (
                                <Grid item xs>
                                    <Typography variant="h4" className={titleClass || classes.titleClass} id="responsive-dialog-title">
                                        {titleText}
                                    </Typography>
                                </Grid>
                            )}
                            {showCloseButton && (
                                <Grid item className={classes.cancelBtn}>
                                    <CloseIcon onClick={onClose} />
                                </Grid>
                            )}
                        </Grid>
                    )}

                    {showDivider && <Divider sx={{ borderColor: theme.palette.grey[500] }} />}
                </DialogTitle>
            )}
            <DialogContent>
                <DialogContentText>{bodyText}</DialogContentText>
            </DialogContent>
            {ActionsComponent && (
                <DialogActions>
                    <ActionsComponent />
                </DialogActions>
            )}
        </Dialog>
    );
};

export default DialogModal;

DialogModal.propTypes = {
    open: PropTypes.bool,
    titleText: PropTypes.string,
    bodyText: PropTypes.func,
    maxWidth: PropTypes.string,
    onClose: PropTypes.func,
    disableBackdropClick: PropTypes.bool,
    disableEscapeKeyDown: PropTypes.bool,
    showDivider: PropTypes.bool,
    hideTitle: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    titleClass: PropTypes.string
};
